import { ISection } from 'src/types/menu.types';

export interface ICategoryWithChildren extends ISection {
  children: ICategoryWithChildren[];
}

export const createCategoriesHierarchy = (
  categories: ISection[],
  parentSectionId: string | null = null,
): ICategoryWithChildren[] => {
  // filter subcategories for the current category
  const subcategories = categories.filter((category: ISection) => category.parentSectionId === parentSectionId);

  subcategories.sort((a: ISection, b: ISection) => a.displayOrder - b.displayOrder);

  // create categories hierarchy recursively
  return subcategories.map((subcategory: ISection) => ({
    ...subcategory,
    children: createCategoriesHierarchy(categories, subcategory.sectionId),
  }));
};
